type PreferenceStorage = Pick<Storage, "getItem" | "setItem">;

/** Adopt the browser's existing preferences once; new writes use the current app name. */
export function readPreference(storage: PreferenceStorage, key: string): string | null {
  const current = storage.getItem(key);
  if (current !== null || !key.startsWith("leadcue-reply-")) return current;
  const legacy = storage.getItem(key.replace(/^leadcue-reply-/, "booked-"));
  if (legacy !== null) storage.setItem(key, legacy);
  return legacy;
}
